// Presentation.jsx
import { Link } from 'react-router-dom';
import './Presentation.css';
import imagehomedesktop from '../imagesHome/home-image-desktop.png';
import conti from '../imagesHome/conti.png';
import financialmanagement from '../imagesHome/financial-management.gif';
import financeanimation from '../imagesHome/finance-animation.gif';
import Hero from './Hero';
import logo from '../imagesHome/logo-presentation.png';
import AccountCloud from './AccountCloud';
import bazeleconta from '../imagesHome/bazeleconta.png';
import contafinanciara from '../imagesHome/contafinanciara.png';
import level from '../imagesHome/level.png';
import progresscard from '../imagesHome/progress-card.png';
import certificatehfdhsdafkjsdhfkjdshh from '../imagesHome/certifopyrytytutuut.png';
import phonecontalearn from '../imagesHome/phone-contalearn.png';
import phonecontalearngame from '../imagesHome/phone-contalearn-game.png';
import overcourses from '../imagesHome/overcourses.png';
import googleicon from '../header/images/googleicon.png';
import linkedinicon from '../imagesHome/share-linkedin.png';
import CourseCarousel from './CourseCarousel';
import LoginFirstPage from './loginoptions/LoginFirstPage';


import gamesIconFp from '../imagesHome/games-icon-fp.png';








export const Presentation = () => {
  return (
    <main>
      {/* HERO */}
      <section className="lp-hero">
        <div className="container">



      

<div className="hero-login-split">
  <div className="hero-login-split__left">
    <img src={conti} alt="Mascota ContaLearn" className="hero-login-split__image" />
  </div>
  <div className="hero-login-split__right">
    <LoginFirstPage />
  </div>
</div>

<CourseCarousel />


 
      {/* BANDĂ SOCIAL PROOF */}
      <section className="lp-band">
        <div className="container band-wrap">
          <h3>Gandit special pentru incepatori</h3>
          <p className="band-subtitle">
            Structura clara, explicatii simple si aplicatii practice
          </p>
         
        </div>
      </section>

</div>
      </section>

{/* BENEFICIU 1 */}


<div className="kicker">Orientat pe self learning</div>
       <section className="beneficiu-section">
      <div className="beneficiu-text">
        <h2 className="beneficiu-title">Invata de oriunde, oricand</h2>

        <div className='text-extra'>
          <p>Pe web sau direct de pe telefon, platforma ContaLearn este mereu gata sa te ajute sa inveti.</p>
          <p>Progresezi in ritmul tau si nu pierzi niciodata firul!</p>

          <p>Acceseaza direct din browser – simplu, rapid si eficient.</p>
        </div>

        <div className="button-fp">
      <Link to='/login' className='link-no-line'>
      <span className='text-button-fp-but'>
        Start
        </span>
      </Link>
      </div>

        
      </div>

      <div className="beneficiu-media">
        <img src={phonecontalearn} alt="Ilustratie lectii de contabilitate" />
      </div>

      <div className="beneficiu-extra">
        <div className='image-extra'>
          <img src={overcourses} />
        </div>

<h2 className="beneficiu-title">Tot ce ai nevoie ca sa intelegi contabilitatea</h2>
        
<div className='text-extra'>
  <p>De la conceptele de baza pana la aplicarea lor in practica, inveti intr-un mod clar si structurat.</p>
  <p>Indiferent daca esti incepator sau vrei sa aprofundezi, aici gasesti resurse clare, moderne si usor de parcurs.</p>

</div>


<div className="button-fp">
  <Link to='/cursuri-prezentare' className='link-no-line'>
  <span className='text-button-fp-but'>
        Vezi toate cursurile
        </span>
  </Link>
      </div>
  
      </div>
    </section>





<div className="kicker">Ce ofera ContaLearn?</div>

     {/* BENEFICIU 2 */}
<section className="container-middle-section">
  <div className="card-fp">
    <div className="img-fp">
      <img src={level} />
    </div>
    <h3 className="title-fp">Gandit pentru orice nivel</h3>
    <p className="text-fp">
      Incepi de la zero sau vrei sa aprofundezi? Lectiile noastre sunt structurate astfel incat sa inveti clar si aplicat, indiferent de experienta.
    </p>
    <div className="button-fp">
      <Link to='/quiz-start' className='link-no-line'>
      <span className='text-button-fp-but'>Incepe sa inveti</span>
      </Link>
    </div>
  </div>

  <div className="card-fp">
    <div className="img-fp">
      <img src={certificatehfdhsdafkjsdhfkjdshh} />
    </div>
    <h3 className="title-fp">Pasi mici, progres constant</h3>
    <p className="text-fp">
      Parcurgi lectii pas cu pas, verifici ce ai invatat si <strong>iti consolidezi cunostintele prin practica</strong>. Simplu, interactiv si eficient.
    </p>
    <div className="button-fp">
      <Link to='/cursuri-prezentare' className='link-no-line'>
      <span className='text-button-fp-but'>Vezi toate cursurile</span>
      </Link>
    </div>
  </div>

  <div className="card-fp">
    <div className="img-fp">
     <img src={progresscard} />
    </div>
    <h3 className="title-fp">Certificare inclusa</h3>
    <p className="text-fp">
      <strong>Obtine un certificat</strong> care atesta ce ai invatat. Il poti adauga in CV sau il poti distribui pe retelele sociale.
    </p>
    <div className="button-fp">
      <Link to='/login' className='link-no-line'>
      <span className='text-button-fp-but'>Obtine certificatul</span>
      </Link>
    </div>
  </div>
</section>
  {/* PRICING - Modern Design 

<div className="kicker">Pret</div>
  

    
      <section className="pricing-section-modern">
        <div className="pricing-container-modern">
          
          
          <div className="pricing-card-modern">
            <div className="plan-badge">GRATUIT</div>
            <h3 className="plan-name">Plan de Start</h3>
            <div className="plan-price-modern">
              <span className="price-number">0</span>
              <span className="price-currency">RON</span>
            </div>
            <p className="plan-subtitle">Perfect pentru a incepe</p>
            
            <ul className="features-list-modern">
              <li className="feature-modern active">✓ 5 lectii pe saptamana</li>
              <li className="feature-modern active">✓ Acces la comunitate</li>
              <li className="feature-modern inactive">× Exercitii practice</li>
              <li className="feature-modern inactive">× Certificare</li>
              <li className="feature-modern inactive">× Jocuri interactive</li>
            </ul>
            
            <Link to="/registrer" className="plan-button-modern outline">
              Incepe gratuit
            </Link>
          </div>

          
          <div className="pricing-card-modern popular">
            <div className="popular-badge">CEL MAI POPULAR</div>
            <div className="plan-badge premium">PREMIUM</div>
            <h3 className="plan-name">Plan Premium</h3>
            <div className="plan-price-modern">
              <span className="price-number">69.99</span>
              <span className="price-currency">RON/luna</span>
            </div>
            <p className="plan-subtitle">Acces complet la tot</p>
            
            <ul className="features-list-modern">
              <li className="feature-modern active">✓ Acces nelimitat la cursuri</li>
              <li className="feature-modern active">✓ 300+ lectii interactive</li>
              <li className="feature-modern active">✓ Jocuri educationale</li>
              <li className="feature-modern active">✓ Exercitii practice</li>
              <li className="feature-modern active">✓ Certificare finalizare</li>
              <li className="feature-modern active highlight">✓ Suport prioritar</li>
            </ul>
            
            <Link to="/viewplans" className="plan-button-modern primary">
              Incepe acum
            </Link>
            <p className="guarantee-modern">💚 Garantie rambursare 14 zile</p>
          </div>

          
          <div className="pricing-card-modern">
            <div className="plan-badge savings">ECONOMISESTI 35%</div>
            <h3 className="plan-name">Plan Anual</h3>
            <div className="plan-price-modern">
              <span className="price-number">549</span>
              <span className="price-currency">RON/an</span>
            </div>
            <p className="plan-subtitle">Doar 45.75 RON/luna</p>
            
            <ul className="features-list-modern">
              <li className="feature-modern active">✓ Tot ce include Premium</li>
              <li className="feature-modern active">✓ Acces prioritar continut nou</li>
              <li className="feature-modern active">✓ Sesiuni 1-on-1 (optional)</li>
              <li className="feature-modern active highlight">✓ Economisesti 289 RON</li>
            </ul>
            
            <Link to="/viewplans" className="plan-button-modern">
              Vezi planul anual
            </Link>
          </div>

        </div>

    
      </section>


<div className='button-view-plans'>
  <Link to="/viewplans" className="cta-view-plans">
    <span>Vezi toate planurile</span>
  </Link>
</div>

 */}

   <section className="beneficiu-section-games">
        <div className="games-section-fp-second">
    <h2 className="motivation-title">Invata contabilitate jucandu-te</h2>
    

    <div className="games-summary">
      <div className="game-item">
        <h3 className="game-title">Cum functioneaza conturile?</h3>
        <p>Exemple reale te ajuta sa intelegi cum se folosesc conturile in practica.</p>
      </div>

      <div className="game-item">
        <h3 className="game-title">Identifica tipul contului</h3>
        <p>Active, pasive, venituri sau cheltuieli – vezi cat de repede le recunosti.</p>
      </div>

      <div className="game-item">
        <h3 className="game-title">Planul de conturi</h3>
        <p>Asociaza rapid codurile conturilor. Perfect pentru recapitulare sau examen!</p>
      </div>
    </div>

    <div className="button-fp-games">
      <span className="text-button-fp-but-games">Joaca jocurile</span>
    </div>
  </div>

      <div className="beneficiu-media-games">
       <img src={phonecontalearngame} alt="Jocuri interactive" />
      </div>

      <div className="beneficiu-extra-games">
        <div className='image-extra'>
          <img src={gamesIconFp} />
        </div>

<h2 className="beneficiu-title">Transforma invatarea in joaca</h2>
        
<div className='text-extra'>
  <p> Testeaza-ti cunostintele si exerseaza conceptele prin jocuri interactive.</p>
  <p>Fiecare joc este creat pentru a face invatarea mai usoara si mai eficienta.</p>

</div>


<div className="button-fp">
      <span className='text-button-fp-but'>
        Vezi toate Jocurile
        </span>
      </div>
  
      </div>
    </section>










    


      {/* TESTIMONIALS Section 
      <section className="testimonials-section-fp">
        <div className="kicker">Ce spun utilizatorii nostri</div>
        <h2 className="testimonials-title">Peste 10,000 de studenti au ales ContaLearn</h2>
        
        <div className="testimonials-grid-fp">
          <div className="testimonial-card-fp">
            <div className="testimonial-stars">⭐⭐⭐⭐⭐</div>
            <p className="testimonial-text">
              "ContaLearn m-a ajutat sa inteleg contabilitatea de la zero. Acum lucrez ca contabil si totul datorita acestei platforme!"
            </p>
            <div className="testimonial-author">
              <strong>Maria Popescu</strong>
              <span>Contabil junior</span>
            </div>
          </div>

          <div className="testimonial-card-fp">
            <div className="testimonial-stars">⭐⭐⭐⭐⭐</div>
            <p className="testimonial-text">
              "Lectiile sunt clare, structurate logic si usor de urmat. Jocurile interactive fac invatarea mai interesanta."
            </p>
            <div className="testimonial-author">
              <strong>Ion Ionescu</strong>
              <span>Student</span>
            </div>
          </div>

          <div className="testimonial-card-fp">
            <div className="testimonial-stars">⭐⭐⭐⭐⭐</div>
            <p className="testimonial-text">
              "Certificatul primit la final m-a ajutat sa imi gasesc un job mai bun. Investitia perfecta in cariera mea!"
            </p>
            <div className="testimonial-author">
              <strong>Elena Dumitrescu</strong>
              <span>Specialist financiar</span>
            </div>
          </div>
        </div>
      </section>
      */}

      {/* CTA FINAL - Modernized */}
      <section className='final-cta-modern'>
        <div className='cta-pattern-overlay'></div>
        <div className="lp-cta-modern">
          


          {/* Main CTA Content */}
          <div className="cta-main-content">
            <div className="cta-text-section">
              <div className="cta-badge">Incepe acum</div>
              <h2 className="cta-main-title">Alaturate comunitatii ContaLearn</h2>
              <p className="cta-main-subtitle">
                Incepe sa inveti contabilitate astazi!
              </p>
              
              {/* Benefits List */}
              <div className="cta-benefits-list">
                <div className="cta-benefit-item">
                  <span className="benefit-check">✓</span>
                  <span>Acces la toate cursurile</span>
                </div>
                {/* <div className="cta-benefit-item">
                <div className="cta-benefit-item">
                  <span className="benefit-check">✓</span>
                  <span>Certificare la finalizarea fiecarui curs</span>
                </div>
                */}
                
              </div>
            </div>

            {/* Registration Form */}
            <div className="cta-form-section">
              <div className="cta-form-card">
                <h3 className='cta-form-title'>Creeaza cont gratuit!</h3>
                <p className="cta-form-subtitle">Fa primul pas catre contabilitate!</p>

              


                    <div className='cta-social-section'>
                  <div className='cta-social-buttons'>
                    <Link to='/quiz-start' className='cta-social-btn cta-social-btn--google'>
                      <img src={googleicon} alt='Google icon' />
                      <span>Inregistrare cu Google</span>
                    </Link>

                    <Link to='/quiz-start' className='cta-social-btn cta-social-btn--linkedin'>
                      <img src={linkedinicon} alt='LinkedIn icon' />
                      <span>Inregistrare cu LinkedIn</span>
                    </Link>
                  </div>
                </div>
                
                <div className='cta-divider'>
                  <span>sau</span>
                </div>
                
              <Link to='/quiz-start' className='cta-quiz-primary'>
                  <span>Creeaza cont</span>
                </Link>

             
              </div>
            </div>
          </div>

     

        </div>
      </section>


     
    </main>
  );
};
